import { TextInput } from '@portals/forms/src/components/TextInput/TextInput';
import { getFixedT } from 'i18next';
import React from 'react';

import { onTouchInputFieldProps } from '../../../../../../../hooks/usePreventSafariAutozoom/usePreventSafariAutozoom';

interface MessageSectionProps {
  preventSafariAutozoom: onTouchInputFieldProps;
}

const t = getFixedT(null, 'core-immobilien');

export const MessageSection = ({ preventSafariAutozoom }: MessageSectionProps): React.ReactElement => {
  return (
    <>
      <TextInput fullWidth label={t('contactForm.subject')} name="subject" />
      <TextInput
        fullWidth
        label={t('contactForm.message')}
        placeholder={t('contactForm.message')}
        type="single"
        name="message"
        minRows={4}
        maxRows={7}
        multiline
        sx={{
          '& .MuiInputBase-multiline': {
            padding: 0,
          },
        }}
        {...preventSafariAutozoom}
      />
    </>
  );
};

MessageSection.displayName = 'MessageSection';
